import socket from '../socketConfig'
import { useBudgetStore } from '@/store/budget'

const CONTEXT = 'budget'

const budgetHandler = {
  setupEventListeners(): void {
    socket.on(`${CONTEXT}:created`, (budget: any) => {
      const budgetStore = useBudgetStore()
      // Recarregar orçamentos do paciente se o budget tiver patientId
      if (budget.patientId) {
        budgetStore.getBudgetByPatientId(budget.patientId)
      }
    })

    socket.on(`${CONTEXT}:updated`, (budget: any) => {
      const budgetStore = useBudgetStore()
      // Recarregar orçamentos do paciente se o budget tiver patientId
      if (budget.patientId) {
        budgetStore.getBudgetByPatientId(budget.patientId)
      }
    })

    socket.on(`${CONTEXT}:statusUpdated`, (budget: any) => {
      const budgetStore = useBudgetStore()
      // Recarregar orçamentos do paciente se o budget tiver patientId
      if (budget.patientId) {
        budgetStore.getBudgetByPatientId(budget.patientId)
      }
    })

    socket.on(`${CONTEXT}:deleted`, (budget: any) => {
      const budgetStore = useBudgetStore()
      // Recarregar orçamentos do paciente se o budget tiver patientId
      if (budget.patientId) {
        budgetStore.getBudgetByPatientId(budget.patientId)
      }
    })
  },

  removeEventListeners(): void {
    socket.off(`${CONTEXT}:created`)
    socket.off(`${CONTEXT}:updated`)
    socket.off(`${CONTEXT}:statusUpdated`)
    socket.off(`${CONTEXT}:deleted`)
  }
}

export default budgetHandler

